/*
  This is the original html structure for the algolia-hit component. Adding it here for reference and any needed future debugging.
*/

// <div class="card-wrapper product-card-wrapper">
//   <div
//     class="
//       card
//       card--${this.settings.cardStyle}
//       ${featuredMedia ? "card--media" : "card--text"}
//       ${this.settings.cardStyle === "card" ? `color-${this.settings.cardColorScheme} gradient` : ""}
//       ${this.settings.extendHeight ? "card--extend-height" : ""}
//       ${!featuredMedia && this.settings.cardStyle === "card" ? "ratio" : ""}
//       ${this.settings.horizontalClass ? "card--horizontal" : ""}
//     "
//     style="--ratio-percent:${1 / this.settings.imgAspectRatio * 100}%;"
//   >
//     <div
//       class="
//         card__inner
//         ${this.settings.cardStyle === "standard" ? `color-${this.settings.cardColorScheme} gradient` : ""}
//         ${featuredMedia || this.settings.cardStyle === "card" ? "ratio" : ""}
//       "
//       style="--ratio-percent:${1 / this.settings.imgAspectRatio * 100}%;"
//     >
//     ${isMixedStyles ? `
//       <style>
//         .product__badge {
//           position: absolute;cre
//           padding: ${this.settings.productBadgePaddingYCard}px ${this.settings.productBadgePaddingXCard}px;
//         }
//       </style>
//       <div class="product__badge ${this.settings.productBadgeTextSizeProductCard} ${this.settings.productBadgeVerticalPosition} ${this.settings.productBadgeHorizontalPosition}">
//         ${productBadgeContent}
//       </div>
//     ` : ""}
//       ${featuredMedia ? `
//         <div class="card__media">
//           <div class="media--transparent media ${this.settings.enableZoomImage}">
//             ${isMixedStyles ? mixedStylesCardProductContent : `
//               <img
//                 srcset="
//                   ${featuredMedia}&width=165 165w,
//                   ${featuredMedia}&width=360 360w,
//                   ${featuredMedia}&width=533 533w,
//                   ${featuredMedia}&width=720 720w,
//                   ${featuredMedia}&width=940 940w,
//                   ${featuredMedia}&width=1066 1066w
//                 "
//                 src="${featuredMedia}&width=533"
//                 sizes="(min-width: ${this.settings.pageWidth}px) ${(this.settings.pageWidth - 130) / 4}px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
//                 alt="${item.title}"
//                 onerror="this.onerror=null;this.src='${this.settings.mediaCameraShy}'"
//                 class="motion-reduce"
//                 ${item.isLazyLoad ? `loading="lazy"` : ""}
//                 width="auto"
//                 height="auto"
//               >
//             `}
//           </div>
//         </div>
//       ` : ""}
//       <div class="card__content">
//         <div class="card__information">
//           ${!featuredMedia && this.settings.cardStyle === "standard" ? `
//             <h3
//               class="card__heading line-clamp-3 md:line-clamp-2 ${this.settings.typeProductCardNameAllCaps ? "p-all-caps" : ""}"
//               id="title-${item.id}"
//             >
//               <a
//                 href="${productUrl}"
//                 id="StandardCardNoMediaLink-${item.id}"
//                 class="full-unstyled-link"
//                 aria-labelledby="StandardCardNoMediaLink-${item.id} NoMediaStandardBadge-${item.id}"
//               >
//                 ${item.title}
//               </a>
//               <div class="card__subfield">
//                 <p class="card__color card__subfield-text">
//                   ${colors.map(color => `<span>${color}</span>`)}
//                 </p>
//               </div>
//             </h3>
//           ` : ""}
//         </div>
//         <div class="card__badge ${this.settings.badgePosition}">
//           ${!item.inventory_available ? `
//             <span
//               id="NoMediaStandardBadge-${item.id}"
//               class="badge badge--bottom-left color-${this.settings.soldOutBadgeColorScheme}"
//             >
//               ${this.settings.soldOut}
//             </span>
//           ` : ""}
//           ${this.settings.saleBadgeRenderLocation === "over_product_image" ? badgeSaleContent : ""}
//         </div>
//       </div>
//     </div>
//     <div class="card__content">
//       <div class="card__information">
//         <h3
//           class="card__heading line-clamp-3 md:line-clamp-2 ${this.settings.typeProductCardNameAllCaps ? "p-all-caps" : ""}"
//           ${featuredMedia || this.settings.cardStyle === 'card' ? `id="title-${item.id}"` : ""}
//         >
//           <a
//             href="${productUrl}"
//             id="CardLink-${item.id}"
//             class="full-unstyled-link card__product-url"
//             aria-labelledby="CardLink-${item.id} Badge-${item.id}"
//             ${this.settings.openProductsInNewTab ? `target="_blank"` : ""}
//           >
//             ${item.title}
//           </a>
//         </h3>
//         ${this.settings.typeProductCardSubfieldShow ? `
//           <div class="card__subfield">
//             ${this.settings.typeProductCardShowGender ? `
//               <p class="card__gender card__subfield-text">${gender}</p>
//               <span class="card__info-divider">${this.settings.typeProductCardInfoDivider}</span>
//             ` : ""}
//             <p class="card__color card__subfield-text">
//               ${colors.map(color => `<span>${color}</span>`)}
//               ${width ? `
//                 <span class="card__info-divider">${this.settings.typeProductCardInfoDivider}</span>
//                 ${width}
//               ` : ""}
//             </p>
//             ${this.settings.isUnstacked ? `
//               <span class="card__info-divider">${this.settings.typeProductCardInfoDivider}</span>
//               <p class="card__size card__subfield-text">${item.option1 ? item.option1 : ""}</p>
//               <span class="card__info-divider">${this.settings.typeProductCardInfoDivider}</span>
//               <p class="card__condition card__subfield-text">${item.option2 ? item.option2 : ""}</p>
//             ` : ""}
//           </div>
//         ` : ""}
//         <div class="card-information">
//           ${this.settings.showVendor ? `
//             <span class="visually-hidden">${this.settings.vendor}</span>
//             <div class="caption-with-letter-spacing light">${item.vendor}</div>
//           ` : ""}
//           <span class="caption-large light">${this.settings.description}</span>
//           ${this.settings.saleBadgeRenderLocation === "product_info" ? badgeSaleContent : ""}
//           ${priceContent}
//         </div>
//       </div>
//       <div class="card__badge ${this.settings.badgePosition}">
//         ${!item.inventory_available ? `
//           <span
//             id="Badge-${item.id}"
//             class="badge badge--bottom-left color-${this.settings.soldOutBadgeColorScheme}"
//           >
//             ${this.settings.soldOut}
//           </span>
//         ` : (item.compare_at_price > item.price && item.inventory_available) ? `
//           <span
//             id="Badge-${item.id}"
//             class="badge badge--bottom-left color-${this.settings.saleBadgeColorScheme}"
//           >
//             ${this.settings.onSale}
//           </span>
//         ` : ""}
//       </div>
//     </div>
//   </div>
// </div>

class AlgoliaHit extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getCatalogItemType = this.getCatalogItemType.bind(this);
    this.getColorCode = this.getColorCode.bind(this);
    this.getColors = this.getColors.bind(this);
    this.getGender = this.getGender.bind(this);
    this.getParentSku = this.getParentSku.bind(this);
    this.getWidth = this.getWidth.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      useAlgoliaFullPdpUrlParams: this.getAttribute('use-algolia-full-pdp-url-params').toLowerCase() === 'true',
      badgePosition: this.getAttribute('badge-position'),
      cardColorScheme: this.getAttribute('card-color-scheme'),
      cardStyle: this.getAttribute('card-style'),
      description: this.getAttribute('description'),
      enableZoomImage: this.getAttribute('enable-zoom-image'),
      extendHeight: this.getAttribute('extend-height').toLowerCase() === 'true',
      horizontalClass: this.getAttribute('horizontal-class').toLowerCase() === 'true',
      imgAspectRatio: this.getAttribute('img-aspect-ratio'),
      isUnstacked: this.getAttribute('is-unstacked').toLowerCase() === 'true',
      mediaCameraShy: this.getAttribute('media-camera-shy'),
      mixedStyles: this.getAttribute('mixed-styles'),
      onSale: this.getAttribute('on-sale'),
      openProductsInNewTab: this.getAttribute('open-products-in-new-tab').toLowerCase() === 'true',
      pageWidth: this.getAttribute('page-width'),
      productBadgeHorizontalPosition: this.getAttribute('product-badge-horizontal-position'),
      productBadgePaddingYCard: this.getAttribute('product-badge-padding-y-card'),
      productBadgePaddingXCard: this.getAttribute('product-badge-padding-x-card'),
      productBadgeTextSizeProductCard: this.getAttribute('product-badge-text-size-product-card'),
      productBadgeVerticalPosition: this.getAttribute('product-badge-vertical-position'),
      saleBadgeColorScheme: this.getAttribute('sale-badge-color-scheme'),
      saleBadgeRenderLocation: this.getAttribute('sale-badge-render-location'),
      showVendor: this.getAttribute('show-vendor').toLowerCase() === 'true',
      soldOut: this.getAttribute('sold-out'),
      soldOutBadgeColorScheme: this.getAttribute('sold-out-badge-color-scheme'),
      typeProductCardInfoDivider: this.getAttribute('type-product-card-info-divider'),
      typeProductCardNameAllCaps: this.getAttribute('type-product-card-name-all-caps').toLowerCase() === 'true',
      typeProductCardShowGender: this.getAttribute('type-product-card-show-gender').toLowerCase() === 'true',
      typeProductCardSubfieldShow: this.getAttribute('type-product-card-subfield-show').toLowerCase() === 'true',
      vendor: this.getAttribute('vendor')
    }
  }

  /**
   * Retrieves the catalog item type from the given item's metadata.
   * @param {Object} item - The item object containing metadata.
   * @returns {string} The extracted catalog item type from the item's metadata.
   */
  getCatalogItemType(item) {
    const troveFacets = item?.meta['trove-facets'];
    const catalogItemType = troveFacets?.catalogItemType?.toString() || '';
    return catalogItemType;
  }

  /**
   * Retrieves the parent sku from the given item's metadata.
   * @param {Object} item - The item object containing metadata.
   * @returns {string} The extracted parent sku from the item's metadata.
   */
  getColorCode(item) {
    const troveProduct = item?.meta['trove-product'];
    const colorCode = troveProduct?.color_code?.toString() || '';
    return colorCode;
  }

  /**
   * Retrieves an array of colors from the given item's metadata.
   * @param {Object} item - The item object containing metadata.
   * @returns {string[]} An array of colors extracted from the item's metadata.
   */
  getColors(item) {
    const troveProduct = item?.meta['trove-product'];
    const troveColors = troveProduct?.color_display?.toString() || '';
    const colors = troveColors.split('/');
    return colors;
  }

  /**
   * Retrieves the gender from the given item's metadata.
   * @param {Object} item - The item object containing metadata.
   * @returns {string} The extracted gender from the item's metadata.
   */
  getGender(item) {
    const troveFacets = item?.meta['trove-facets'];
    const troveGender = troveFacets?.gender?.toString() || '';
    const gender = troveGender.replace("'s", '').replace('["', '').replace('"]', '');
    return gender;
  }

  /**
   * Retrieves the parent sku from the given item's metadata.
   * @param {Object} item - The item object containing metadata.
   * @returns {string} The extracted parent sku from the item's metadata.
   */
  getParentSku(item) {
    const troveProduct = item?.meta['trove-product'];
    const parentSku = troveProduct?.parent_sku?.toString() || '';
    return parentSku;
  }

  /**
   * Retrieves the width from the given item's metadata.
   * @param {Object} item - The item object containing metadata.
   * @returns {string} The extracted width from the item's metadata.
   */
  getWidth(item) {
    const troveFacets = item?.meta['trove-facets'];
    const troveWidth = troveFacets?.width?.toString() || '';
    const width = troveWidth.replace('["', '').replace('"]', '');
    return width;
  }

  createCardWrapper() {
    const div = document.createElement('div');
    div.classList.add('card-wrapper', 'product-card-wrapper');
    return div;
  }

  createCard({ featuredMedia }) {
    const div = document.createElement('div');
    div.classList.add(
      'card',
      `card--${this.settings.cardStyle}`,
    );
    if (featuredMedia) {
      div.classList.add('card--media');
    }
    if ( this.settings.cardStyle === 'card') div.classList.add(`color-${this.settings.cardColorScheme}`, 'gradient');
    if (this.settings.extendHeight) div.classList.add('card--extend-height');
    if (!featuredMedia && this.settings.cardStyle === 'card') div.classList.add('ratio');
    if (this.settings.horizontalClass) div.classList.add('card--horizontal');

    div.style = `--ratio-percent:${1 / this.settings.imgAspectRatio * 100}%;`;
    return div;
  }

  createCardInner({ featuredMedia}) {
    const div = document.createElement('div');
    div.classList.add(
      'card__inner',
    );
    if (this.settings.cardStyle === 'standard') div.classList.add(`color-${this.settings.cardColorScheme}`, 'gradient');
    if (featuredMedia || this.settings.cardStyle === 'card') div.classList.add('ratio');

    div.style = `--ratio-percent:${1 / this.settings.imgAspectRatio * 100}%;`;
    return div;
  }

  createMixedStylesBadgeStyles() {
    const style = document.createElement('style');
    const css = `
      .product__badge {
        position: absolute;
        padding: ${this.settings.productBadgePaddingYCard}px ${this.settings.productBadgePaddingXCard}px;
      }
    `;

    style.appendChild(document.createTextNode(css));
    return style;
  }

  createProductBadge(productBadgeContent) {
    const div = document.createElement('div');
    div.classList.add(
      'product__badge',
      this.settings.productBadgeTextSizeProductCard,
      this.settings.productBadgeVerticalPosition,
      this.settings.productBadgeHorizontalPosition
    );
    productBadgeContent.forEach(el => div.appendChild(el));
    return div;
  }

  createCardMedia({ featuredMedia, isMixedStyles, mixedStylesCardProductContent, item }) {
    const div = document.createElement('div');
    div.classList.add('card__media');

    const mediaDiv = document.createElement('div');
    mediaDiv.classList.add('media--transparent', 'media');
    if(this.settings.enableZoomImage) mediaDiv.classList.add(this.settings.enableZoomImage);

    const img = document.createElement('img');
    img.srcset = `
      ${featuredMedia}&width=165 165w,
      ${featuredMedia}&width=360 360w,
      ${featuredMedia}&width=533 533w,
      ${featuredMedia}&width=720 720w,
      ${featuredMedia}&width=940 940w,
      ${featuredMedia}&width=1066 1066w
    `;
    img.src = `${featuredMedia}&width=533`;
    img.sizes = `(min-width: ${this.settings.pageWidth}px) ${(this.settings.pageWidth - 130) / 4}px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)`;
    img.alt = item.title;
    img.onerror = "this.onerror=null;this.src='${this.settings.mediaCameraShy}'";
    img.classList.add('motion-reduce');
    if (item.isLazyLoad) {
      img.loading = 'lazy';
    }
    img.width = 'auto';
    img.height = 'auto';

    if (isMixedStyles) {
      mixedStylesCardProductContent.forEach(el => mediaDiv.appendChild(el));
    } else {
      mediaDiv.appendChild(img);
    }
    div.appendChild(mediaDiv);
    return div;
  }

  createCardContent() {
    const div = document.createElement('div');
    div.classList.add('card__content');
    return div;
  }

  createCardInformation({featuredMedia, item, colors, productUrl}) {
    const div = document.createElement('div');
    div.classList.add('card__information');
    if (!featuredMedia && this.settings.cardStyle === 'standard') {
      const h3 = document.createElement('h3');
      h3.classList.add('card__heading', 'line-clamp-3', 'md:line-clamp-2', this.settings.typeProductCardNameAllCaps ? 'p-all-caps' : '');
      h3.id = `title-${item.id}`;

      const a = document.createElement('a');
      a.href = productUrl;
      a.id = `StandardCardNoMediaLink-${item.id}`;
      a.classList.add('full-unstyled-link');
      a.setAttribute('aria-labelledby', `StandardCardNoMediaLink-${item.id} NoMediaStandardBadge-${item.id}`);
      a.textContent = item.title;

      const subfieldDiv = document.createElement('div');
      subfieldDiv.classList.add('card__subfield');
      const p  = document.createElement('p');
      p.classList.add('card__color', 'card__subfield-text');
     colors.forEach(color => {
        const span = document.createElement('span');
        span.textContent = color;
        p.appendChild(span);
      });
      subfieldDiv.appendChild(p);
      h3.appendChild(a);
      h3.appendChild(subfieldDiv);
      div.appendChild(h3);
    }
    return div;
  }

  createCardBadge({ item, badgeSaleContent }) {
    const div = document.createElement('div');
    div.classList.add('card__badge');
    if (this.settings.badgePosition) {
      // this setting can be values like 'bottom left'
      this.settings.badgePosition.split(' ').forEach(position => div.classList.add(position));
    }
    if (!item.inventory_available) {
      const span = document.createElement('span');
      span.id = `NoMediaStandardBadge-${item.id}`;
      span.classList.add('badge', 'badge--bottom-left', `color-${this.settings.soldOutBadgeColorScheme}`);
      span.textContent = this.settings.soldOut;
      div.appendChild(span);
    }
    if (this.settings.saleBadgeRenderLocation === 'over_product_image') {
      badgeSaleContent.forEach(el => div.appendChild(el));
    }
    return div;
  }

  createCardInformation2({ featuredMedia, item, productUrl }) {
    const div = document.createElement('div');
    div.classList.add('card__information');
    const h3 = document.createElement('h3');
    h3.classList.add('card__heading', 'line-clamp-3', 'md:line-clamp-2');
    if ( this.settings.typeProductCardNameAllCaps ) h3.classList.add('p-all-caps');
    if (featuredMedia || this.settings.cardStyle === 'card') {
      h3.id = `title-${item.id}`;
    }
    const a = document.createElement('a');
    a.href = productUrl;
    a.id = `CardLink-${item.id}`;
    a.classList.add('full-unstyled-link', 'card__product-url');
    a.setAttribute('aria-labelledby', `CardLink-${item.id} Badge-${item.id}`);
    if (this.settings.openProductsInNewTab) {
      a.target = '_blank';
    }
    a.textContent = item.title;
    h3.appendChild(a);
    div.appendChild(h3);
    return div;
  }

  createCardSubfield({ gender, colors, width, item }) {
    const div = document.createElement('div');
    div.classList.add('card__subfield');

    if (this.settings.typeProductCardShowGender) {
      const p = document.createElement('p');
      p.classList.add('card__gender', 'card__subfield-text');
      p.textContent = gender;
      div.appendChild(p);
      const span = document.createElement('span');
      span.classList.add('card__info-divider');
      span.textContent = this.settings.typeProductCardInfoDivider;
      div.appendChild(span);
    }

    const p = document.createElement('p');
    p.classList.add('card__color', 'card__subfield-text');
    colors.forEach(color => {
      const span = document.createElement('span');
      span.textContent = color;
      p.appendChild(span);
    });

    if (width) {
      const span = document.createElement('span');
      span.classList.add('card__info-divider');
      span.textContent = this.settings.typeProductCardInfoDivider;
      p.appendChild(span);
      const text = document.createTextNode(width);
      p.appendChild(text);
    }

    div.appendChild(p);

    if (this.settings.isUnstacked) {
      const span = document.createElement('span');
      span.classList.add('card__info-divider');
      span.textContent = this.settings.typeProductCardInfoDivider;
      div.appendChild(span);
      const p = document.createElement('p');
      p.classList.add('card__size', 'card__subfield-text');
      p.textContent = item.option1 ? item.option1 : '';
      div.appendChild(p);
      const span2 = document.createElement('span');
      span2.classList.add('card__info-divider');
      span2.textContent = this.settings.typeProductCardInfoDivider;
      div.appendChild(span2);
      const p2 = document.createElement('p');
      p2.classList.add('card__condition', 'card__subfield-text');
      p2.textContent = item.option2 ? item.option2 : '';
      div.appendChild(p2);
    }

    return div;
  }

  createCardInformation3({ item, badgeSaleContent, priceContent }) {
    const div = document.createElement('div');
    if (this.settings.showVendor) {
      const span = document.createElement('span');
      span.classList.add('visually-hidden');
      span.textContent = this.settings.vendor;
      div.appendChild(span);

      const captionDiv = document.createElement('div');
      captionDiv.classList.add('caption-with-letter-spacing', 'light');
      captionDiv.textContent = item.vendor;
      div.appendChild(captionDiv);
    }

    const captionSpan = document.createElement('span');
    captionSpan.classList.add('caption-large', 'light');
    captionSpan.textContent = this.settings.description;
    div.appendChild(captionSpan);
    if (this.settings.saleBadgeRenderLocation === 'product_info') {
      badgeSaleContent.forEach(el => div.appendChild(el));
    }
    div.appendChild(priceContent);
    return div;
  }

  createCardBadge2({ item }) {
    const div = document.createElement('div');
    div.classList.add('card__badge');
    if (this.settings.badgePosition) {
      // this setting can be values like 'bottom left'
      this.settings.badgePosition.split(' ').forEach(position => div.classList.add(position));
    }
    if (!item.inventory_available) {
      const span = document.createElement('span');
      span.id = `Badge-${item.id}`;
      span.classList.add('badge', 'badge--bottom-left', `color-${this.settings.soldOutBadgeColorScheme}`);
      span.textContent = this.settings.soldOut;
      div.appendChild(span);
    }else if (item.compare_at_price > item.price && item.inventory_available) {
      const span = document.createElement('span');
      span.id = `Badge-${item.id}`;
      span.classList.add('badge', 'badge--bottom-left', `color-${this.settings.saleBadgeColorScheme}`);
      span.textContent = this.settings.onSale;
      div.appendChild(span);
    }

    return div;
  }

  /**
   * Renders the content.
   * @param {Object} instances - Instances object containing algolia instances.
   * @param {Object} item - The item object containing information about the hit.
   * @returns {string} The rendered content HTML.
   */
  render(instances, item) {
    /* Metadata. */
    const catalogItemType = this.getCatalogItemType(item);
    const colorCode = this.getColorCode(item);
    const colors = this.getColors(item);
    const gender = this.getGender(item);
    const parentSku = this.getParentSku(item);
    const width = this.getWidth(item);

    const featuredMedia = item.product_image || this.settings.mediaCameraShy;
    const isMixedStyles = catalogItemType.includes('OPEN_SKU');

    /* Elements. */
    const badgeSaleElement = this.querySelector('algolia-badge-sale');
    const mixedStylesCardProductElement = this.querySelector('algolia-mixed-styles-card-product');
    const priceElement = this.querySelector('algolia-price');
    const productBadgeElement = this.querySelector('algolia-product-badge');
    const customBadgesElement = this.querySelector('algolia-custom-badges');

    /* Content. */
    const badgeSaleContent = badgeSaleElement ? badgeSaleElement.render(item) : [];
    const mixedStylesCardProductContent = mixedStylesCardProductElement ? mixedStylesCardProductElement.render(colorCode, parentSku) : [];
    const priceContent = priceElement ? priceElement.render(item) : [];
    const productBadgeContent = productBadgeElement ? productBadgeElement.render(this.settings?.mixedStyles) : [];
    const customBadgesContent = customBadgesElement ? customBadgesElement?.render(item, isMixedStyles) : []

    /* Product url link */
    let  productUrl = instances.algoliaShopify.helpers.instantsearchLink(item);
    if (!this.settings.useAlgoliaFullPdpUrlParams) {
      productUrl = productUrl.split('?')[0];
    }

    const cardWrapper = this.createCardWrapper();

    // These are the top half of a product card's html
    const card = this.createCard({ featuredMedia});
    const cardInner = this.createCardInner({ featuredMedia});

    const cardMedia = this.createCardMedia({ featuredMedia, isMixedStyles, mixedStylesCardProductContent, item });
    const cardContent = this.createCardContent();
    const cardInformation = this.createCardInformation({ featuredMedia, item, colors, productUrl });

    // These are the bottom half of a product card's html
    const cardContent2 = this.createCardContent();
    const cardInformation2 = this.createCardInformation2({ featuredMedia, item, productUrl });
    const cardSubfield = this.createCardSubfield({ gender, colors, width, item });
    const cardInformation3 = this.createCardInformation3({ item, badgeSaleContent, priceContent });
    const cardBadge2 = this.createCardBadge2({ item });
    const cardBadge = this.createCardBadge({ item, badgeSaleContent})

    // note nesting in comments is to reflect html nesting
    // cardWrapper - returns div that wraps everything
      // card - returns card div that wraps everything
        // cardInner - top half of card
          // mixedStylesBadgeSyles - creates style tag for mixed styles
          // productBadge - creates badge for mixed styles
          // cardMedia - creates media div for card
          // cardContent - returns card content div
            // cardInformation - card content information

      // cardContent 2 - bottom half of card
        // cardInformation2
          // cardSubfield
          // cardInformation3
        // cardBadge2 - card content 2 badge

    if (isMixedStyles) {
      const mixedStylesBadgeSyles = this.createMixedStylesBadgeStyles();
      const productBadge = this.createProductBadge(productBadgeContent);
      cardInner.appendChild(mixedStylesBadgeSyles);
      cardInner.appendChild(productBadge);
    }

    if (customBadgesContent) {
      const customBadgeStyles = document.createElement('style');
      const css = `
        .product__badge {
          position: ${this.settings.saleBadgeRenderLocation === 'product_info' ? 'unset' : 'absolute'};
          padding: ${this.settings.productBadgePaddingYCard}px ${this.settings.productBadgePaddingXCard}px;
        }
      `;
      customBadgeStyles.appendChild(document.createTextNode(css));
      cardInner.appendChild(customBadgeStyles);
      customBadgesContent.forEach(badge => {
        if (this.settings.saleBadgeRenderLocation === 'product_info') {
          badge.forEach(el => cardInformation3.appendChild(el));
        } else {
          badge.forEach(el => cardInner.appendChild(el));
        }
      });
    }

    cardInner.appendChild(cardMedia);
    cardContent.appendChild(cardInformation);
    cardContent.appendChild(cardBadge);
    cardInner.appendChild(cardContent);

    card.appendChild(cardInner);

    cardInformation2.appendChild(cardSubfield);
    cardInformation2.appendChild(cardInformation3);
    cardContent2.appendChild(cardInformation2);
    cardContent2.appendChild(cardBadge2);

    card.appendChild(cardContent2);

    cardWrapper.appendChild(card);
    return cardWrapper;
  }
}

customElements.define("algolia-hit", AlgoliaHit);
